"use client";

import NextError from "next/error";
import { useEffect } from "react";

export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
  useEffect(() => {
    // Log error to console (Sentry removed as part of AWS migration)
    console.error('Global error caught:', error);

    // In production, you could send this to AWS CloudWatch, Application Insights, or other monitoring
    if (process.env.NODE_ENV === 'production') {
      // Future: Send to AWS CloudWatch or monitoring service
      console.error('Production error - digest:', error.digest);
    }
  }, [error]);

  return (
    <html>
      <body>
        {/* `NextError` is the default Next.js error page component. Its type
        definition requires a `statusCode` prop. However, since the App Router
        does not expose status codes for errors, we simply pass 0 to render a
        generic error message. */}
        <NextError statusCode={0} />
      </body>
    </html>
  );
}